export default {
  header: 'Ereignis-Schlagwörter',
  empty: 'Es wurden noch keine Ereignis-Schlagwörter angelegt.',
  confirmDeleteMessage: 'Ereignisse, die dieses Schlagwort tragen, behalten es.',
};
